import React from 'react';
import { AppShell, Group, Title } from '@mantine/core';
import { useNavigate, useLocation } from 'react-router-dom';
import PlatformNavBar from '../../../components/PlatformNavBar';

const Layout = ({ children, onBackToPlatformSelector }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <AppShell
      header={{ height: 70 }}
      padding="md"
    >
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <Group>
            {/* Top-left navigation: exit to platform selector + return to AWS home
                (replaces the former top-right Home icon, consolidating into one place) */}
            {onBackToPlatformSelector && (
              <PlatformNavBar
                onBackToPlatformSelector={onBackToPlatformSelector}
                onBackToHome={() => navigate('/')}
                showHome={!isHome}
                homeLabel="AWS home"
                color="orange"
                mb={0}
              />
            )}
            <Title order={2} c="orange">
              AWS Cloud Exporter
            </Title>
          </Group>
        </Group>
      </AppShell.Header>

      <AppShell.Main>
        {children}
      </AppShell.Main>
    </AppShell>
  );
};

export default Layout;